import { externalScriptPromise } from 'utils/helpers';

let initialized = false;

const initializeBdsTracking = (sessionId) => (
  new Promise((resolve, reject) => {
    /* eslint consistent-return: "off" */
    if (!sessionId) {
      return reject('BDS: no sessionId provided');
    }
    window.bd$cfg = {
      hostUri: 'https://track.bigdatascoring.com',
      accountId: '4f536a68-cd7f-440d-b738-7cfd9552ba7d',
      pageTitle: 'PDPage',
      sessionId,
    };

    // eslint-disable-next-line
    window.bd$exec = function () { (window.bd$queue=window.bd$queue||[]).push(arguments); };
    const bdsScript = externalScriptPromise('https://track.bigdatascoring.com/tracking.min.js', 'bd-tracking');
    bdsScript.then(() => {
      initialized = true;
      return resolve();
    }).catch((error) => console.error(error));
  })
);

const populateFieldsNames = (formName) => {
  const form = document.getElementsByClassName(formName)[0];
  if (!form) {
    return false;
  }
  const fields = form.querySelectorAll('input, select');

  const fieldsNames = Array.from(fields).reduce(
    (result, field) => {
      const fieldName = field.name;
      const isPasswordField = fieldName.toLowerCase().includes('password');
      if (isPasswordField) {
        return result;
      }
      const newValue = {};
      newValue[fieldName] = fieldName;
      return {
        ...result,
        ...newValue,
      };
    },
    {}
  );
  if (!fieldsNames) {
    return false;
  }
  return fieldsNames;
};

const addFields = (formName) => {
  const fieldsNames = populateFieldsNames(formName);
  if (fieldsNames) {
    window.bd$exec('addFields', fieldsNames);
    if (DEBUG) {
      console.log(`window.bd$exec('addFields', '${JSON.stringify(fieldsNames)}');`);
    }
  }
};

export const addBdsTrackingFields = (formName, sessionId) => {
  if (!initialized) {
    initializeBdsTracking(sessionId).then(
      () => addFields(formName),
      (message) => console.error(message)
    );
  } else {
    addFields(formName);
  }
};

export function removeBdsTracking() {
  delete window.bd$cfg;
  delete window.bd$exec;
  delete window.bd$queue;
  document.getElementById('bd-tracking').remove();
  initialized = false;
}

export const bdsTrackingAvailable = () => initialized;
